import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Modal from "react-modal";
import {Col, Container, Row} from "react-bootstrap";
import axios from "axios";
import DataCompareService from "../../../services/DataCompareService";
import UserService from "../../../services/UserService";
import TitleAndInputBox from "../../common/dataView/TitleAndInputBox";
import TitleAndTextArea from "../../common/dataView/TitleAndTextArea";
import ModalCloseButton from "../../common/modal/ModalCloseButton";
import {toast} from "react-toastify";
import ToastAlertView from "../../common/alert/ToastAlertView";
import useAxios from "../../../customHooks/useAxios";


const modalStyle = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
        color: 'black',
        width: '500px',
        height: '340px',
        margin: 'auto'
    }
}

const requestBodyInit = {
    groupName: "",
    description: "",
};

const isValidMapInit = {
    groupName: false,
    description: false,
};

const GroupAdd = ({isOpen, setIsOpen, onRefresh}) => {

    /** New : axios hook */
    const { isAxiosLoading, axiosCall } = useAxios();

    const {t, i18n} = useTranslation();

    /* requestBody */
    const [requestBody, setRequestBody] = useState(requestBodyInit);
    /* validity */
    const [isValidMap, setIsValidMap] = useState(isValidMapInit);
    const [isValid, setIsValid] = useState(false);

    /* duplication */
    const [isNameDuplicationLoading, setIsNameDuplicationLoading] = useState(false);
    const [isNameGood, setIsNameGood] = useState(false);

    /* utils */
    const updateRequestBody = (key, value) => {
        setRequestBody(prevObj => {
            let newObj = {...prevObj};
            newObj[key] = value;
            return newObj;
        });
    };

    const updateIsValidMap = (key, value) => {
        setIsValidMap(prevObj => {
            let newObj = {...prevObj};
            newObj[key] = value;
            return newObj;
        });
    };


    /* handlers */
    const handleGroupNameInput = async (value) => {
        await updateRequestBody("groupName", value);
        await setIsNameDuplicationLoading(true);
        /** check duplication */
        await checkGroupNameDuplication(value);
    };


    const handleDescriptionInput = (value) => {
        updateRequestBody("description", value);
    };


    /* validators */
    const checkGroupNameValidity = () => {
        if (requestBody["groupName"] === "") {
            updateIsValidMap("groupName", false);
        } else {
            updateIsValidMap("groupName", true);
        }
    };

    const checkDescriptionValidity = () => {
        if (requestBody["description"] === "") {
            updateIsValidMap("description", false);
        } else {
            updateIsValidMap("description", true);
        }
    };

    /* check duplication */
    const checkGroupNameDuplication = async (keyword) => {
        try {
            const res = await axiosCall(
                "GET",
                '/group/check/name/duplicate',
                [],
                {},
                null,
                {
                    target: keyword
                },
                "default"
            );
            await setIsNameGood(!res.data.item['isDuplicated']);
        } catch (e) {
            await setIsNameGood(false);
        } finally {
            await setIsNameDuplicationLoading(false);
        }
    };

    /* post group */
    const postGroup = async () => {
        try {
            await axiosCall(
                "POST",
                '/group',
                [],
                requestBody,
                null,
                {},
                "default"
            );
            toast.success(<ToastAlertView message={t("message.saved")} />);
            await onRefresh();
            await initialize();
            await setIsOpen(false);
        } catch (e) {
            toast.error(<ToastAlertView message={t("message.failed")} />);
            console.log(e);
        }
    };

    /* initializer */
    const initialize = () => {
        setRequestBody(requestBodyInit);
        setIsValidMap(isValidMapInit);
    };

    /* effects */
    useEffect(() => {
        initialize();
    }, [isOpen]);

    useEffect(() => {
        setIsValid(DataCompareService.checkIsAllTrue(isValidMap));
    }, [isValidMap]);

    useEffect(() => {
        checkGroupNameValidity();
    }, [requestBody["groupName"]]);
    ;

    useEffect(() => {
        checkDescriptionValidity();
    }, [requestBody["description"]]);


    return (
        <Modal
            style={modalStyle}
            isOpen={isOpen}
            onRequestClose={() => {
                setIsOpen(false);
            }}
        >
            <Container fluid>
                <Row>
                    <ModalCloseButton
                        title={t("menu.groupCompany.group.add.title")}
                        setIsOpen={setIsOpen}
                    />
                </Row>
                <Row>
                    <Col
                        style={{padding: '0px'}}
                    >
                        <TitleAndInputBox
                            title={t("common.name")}
                            value={requestBody["groupName"]}
                            onChange={async (value) => await handleGroupNameInput(value)}
                            isForEdit={true}
                            type={"text"}
                            isValid={isValidMap["groupName"] && isNameGood}
                        />
                    </Col>
                </Row>
                <Row
                    style={{
                        marginTop: '5px'
                    }}
                >
                    <TitleAndTextArea
                        title={t("common.description")}
                        value={requestBody["description"]}
                        onChange={handleDescriptionInput}
                        isForEdit={true}
                        type={"text"}
                        isValid={isValidMap["description"]}
                        height={"60"}
                    />
                </Row>

                <Row
                    style={{
                        marginTop: '20px'
                    }}
                >
                    {
                        (isValid && isNameGood && (!isNameDuplicationLoading))
                            ?
                            <button
                                id={"long-save-btn"}
                                onClick={() => postGroup()}
                            >
                                {t("button.save")}
                            </button>
                            :
                            <button
                                id={"long-save-btn-disabled"}
                            >
                                {t("button.save")}
                            </button>
                    }
                </Row>
            </Container>
        </Modal>
    );
};

export default GroupAdd;